export enum RatHolingErrorId {
  NONE = 0,
  RATHOLING = 1,
  AMOUNT_IS_HIGHER_THEN_MAX_LIMIT = 2,
  AMOUNT_IS_HIGHER_THAN_SESSION_LIMIT = 3,
}
